import deTranslation from './translation/de.json';
import enTranslation from './translation/en.json';
import znTranslation from './translation/zn.json';

export class DataCenter {
  SUPPORT_LANGUAGE: {
    [key: string]: {
      language: string;
      translation: Record<string, string>;
    };
  } = {
    de: {
      language: 'de',
      translation: deTranslation,
    },
    en: {
      language: 'en',
      translation: enTranslation,
    },
    zh: {
      language: 'zh',
      translation: znTranslation,
    },
  };

  LANGUAGE_KEY = 'ln';
  CART_KEY = 'xiang-cart';
  CART_CUSTOMER_KEY = 'xiang-customer';

  HOME_MENU = 'app.home';
  SPECIALITY_MENU = 'app.speciality';
  LUNCH_MENU = 'app.lunch';
  MEDIA_MENU = 'app.media';
  DISCOUNT_MENU = 'app.discount';
  CONTACT_MENU = 'app.contact';
  CART_MENU = 'app.cart';
  MAP_MENU = 'app.map';
}

const dataCenter = new DataCenter();
export default dataCenter;
